//# sourceMappingURL=proposal_element.mjs.map
/// <reference types="./proposal_element.d.mts" />
import * as $bool from "../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../gleam_stdlib/gleam/dict.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $float from "../../gleam_stdlib/gleam/float.mjs";
import * as $int from "../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";
import * as $order from "../../gleam_stdlib/gleam/order.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../gleam_stdlib/gleam/string.mjs";
import * as $timestamp from "../../gleam_time/gleam/time/timestamp.mjs";
import * as $redraw from "../../redraw/redraw.mjs";
import * as $a from "../../redraw_dom/redraw/dom/attribute.mjs";
import * as $h from "../../redraw_dom/redraw/dom/html.mjs";
import * as $dom from "../common/dom.mjs";
import * as $user_id from "../data/auth/user_id.mjs";
import * as $docx from "../data/docx.mjs";
import * as $kind from "../data/docx/kind.mjs";
import * as $block from "../data/proposal_element/block.mjs";
import * as $outline from "../data/proposal_element/outline.mjs";
import * as $one_trust from "../data/proposal_element/portal/one_trust.mjs";
import * as $question from "../data/proposal_element/question.mjs";
import * as $table from "../data/proposal_element/table.mjs";
import * as $language from "../data/translate/language.mjs";
import * as $user from "../data/user.mjs";
import {
  Ok,
  Error,
  toList,
  prepend as listPrepend,
  CustomType as $CustomType,
  isEqual,
} from "../gleam.mjs";

export class Question extends $CustomType {
  constructor(question) {
    super();
    this.question = question;
  }
}
export const ProposalElement$Question = (question) => new Question(question);
export const ProposalElement$isQuestion = (value) => value instanceof Question;
export const ProposalElement$Question$question = (value) => value.question;
export const ProposalElement$Question$0 = (value) => value.question;

export class Table extends $CustomType {
  constructor(table) {
    super();
    this.table = table;
  }
}
export const ProposalElement$Table = (table) => new Table(table);
export const ProposalElement$isTable = (value) => value instanceof Table;
export const ProposalElement$Table$table = (value) => value.table;
export const ProposalElement$Table$0 = (value) => value.table;

export class Block extends $CustomType {
  constructor(block) {
    super();
    this.block = block;
  }
}
export const ProposalElement$Block = (block) => new Block(block);
export const ProposalElement$isBlock = (value) => value instanceof Block;
export const ProposalElement$Block$block = (value) => value.block;
export const ProposalElement$Block$0 = (value) => value.block;

export class Outline extends $CustomType {
  constructor(outline) {
    super();
    this.outline = outline;
  }
}
export const ProposalElement$Outline = (outline) => new Outline(outline);
export const ProposalElement$isOutline = (value) => value instanceof Outline;
export const ProposalElement$Outline$outline = (value) => value.outline;
export const ProposalElement$Outline$0 = (value) => value.outline;

/**
 * Access the `Block` of the `ProposalElement`, iif the item is a block.
 * Otherwise, returns an error.
 */
export function block(el) {
  if (el instanceof Block) {
    let element = el.block;
    return new Ok(element);
  } else {
    return new Error(undefined);
  }
}

/**
 * Used in `decode.failure` functions.
 */
export function empty() {
  return new Block($block.empty());
}

/**
 * Access the `Outline` of the `ProposalElement`, iif the item is a outline.
 * Otherwise, returns an error.
 */
export function outline(el) {
  if (el instanceof Outline) {
    let outline$1 = el.outline;
    return new Ok(outline$1);
  } else {
    return new Error(undefined);
  }
}

/**
 * Access the `Question` of the `ProposalElement`, iif the item is a question.
 * Otherwise, returns an error.
 */
export function question(el) {
  if (el instanceof Question) {
    let question$1 = el.question;
    return new Ok(question$1);
  } else {
    return new Error(undefined);
  }
}

export function decoder() {
  return $decode.field(
    "element_type",
    $kind.decoder(),
    (kind) => {
      if (kind instanceof $kind.Table) {
        let _pipe = $table.decoder();
        return $decode.map(_pipe, (var0) => { return new Table(var0); });
      } else if (kind instanceof $kind.Question) {
        let _pipe = $question.decoder();
        return $decode.map(_pipe, (var0) => { return new Question(var0); });
      } else if (kind instanceof $kind.Section) {
        let _pipe = $block.decoder(false);
        return $decode.map(_pipe, (var0) => { return new Block(var0); });
      } else if (kind instanceof $kind.Subsection) {
        let _pipe = $block.decoder(false);
        return $decode.map(_pipe, (var0) => { return new Block(var0); });
      } else if (kind instanceof $kind.Outline) {
        let _pipe = $outline.outline_decoder();
        return $decode.map(_pipe, (var0) => { return new Outline(var0); });
      } else {
        let _pipe = $block.decoder(false);
        return $decode.map(_pipe, (var0) => { return new Block(var0); });
      }
    },
  );
}

export function encode(el) {
  if (el instanceof Question) {
    let question$1 = el.question;
    return $question.encode(question$1);
  } else if (el instanceof Table) {
    let table = el.table;
    return $table.encode(table);
  } else if (el instanceof Block) {
    let block$1 = el.block;
    return $block.encode(block$1);
  } else {
    let outline$1 = el.outline;
    return $outline.encode_outline(outline$1);
  }
}

/**
 * Access the `element_type` of the `ProposalElement`. If it's a `Block`,
 * returns the `element_type`, otherwise returns `kind.Question` if its a
 * question, or `kind.Table` if it's a table.
 */
export function element_type(el) {
  if (el instanceof Question) {
    return new $kind.Question();
  } else if (el instanceof Table) {
    return new $kind.Table();
  } else if (el instanceof Block) {
    let block$1 = el.block;
    return block$1.element_type;
  } else {
    return new $kind.Outline();
  }
}

/**
 * Access the `content` of the `ProposalElement`.
 *
 * ```gleam
 * fn content(el: ProposalElement) {
 *   case element {
 *     proposal_element.Block(element) -> block.content
 *     proposal_element.Question(question) -> question.content
 *     proposal_element.Table(table) -> table.content
 *   }
 * }
 * ```
 */
export function content(el) {
  if (el instanceof Question) {
    let question$1 = el.question;
    return question$1.content;
  } else if (el instanceof Table) {
    let table = el.table;
    return table.content;
  } else if (el instanceof Block) {
    let block$1 = el.block;
    return block$1.content;
  } else {
    let outline$1 = el.outline;
    return outline$1.content;
  }
}

/**
 * Access to the `Sheet` of the `ProposalElement`, iif the item is a Question
 * Otherwise, returns a None
 */
export function sheet(el) {
  if (el instanceof Question) {
    let q = el.question;
    let $ = q.metadata;
    if ($ instanceof $question.PortalQuestion) {
      return new None();
    } else {
      let sheet_name = $.sheet_name;
      return sheet_name;
    }
  } else if (el instanceof Table) {
    return new None();
  } else if (el instanceof Block) {
    return new None();
  } else {
    return new None();
  }
}

/**
 * Access the `id` of the `ProposalElement`.
 *
 * ```gleam
 * fn id(el: ProposalElement) {
 *   case element {
 *     proposal_element.Block(element) -> block.id
 *     proposal_element.Question(question) -> question.id
 *     proposal_element.Table(table) -> table.id
 *   }
 * }
 * ```
 */
export function id(el) {
  if (el instanceof Question) {
    let q = el.question;
    return q.id;
  } else if (el instanceof Table) {
    let e = el.table;
    return e.id;
  } else if (el instanceof Block) {
    let e = el.block;
    return e.id;
  } else {
    let o = el.outline;
    return o.id;
  }
}

/**
 * Access the `proposal_id` of the `ProposalElement`.
 *
 * ```gleam
 * fn proposal_id(el: ProposalElement) {
 *   case element {
 *     proposal_element.Block(element) -> block.proposal_id
 *     proposal_element.Question(question) -> question.proposal_id
 *     proposal_element.Table(table) -> table.proposal_id
 *   }
 * }
 * ```
 */
export function proposal_id(el) {
  if (el instanceof Question) {
    let q = el.question;
    return q.proposal_id;
  } else if (el instanceof Table) {
    let e = el.table;
    return e.proposal_id;
  } else if (el instanceof Block) {
    let e = el.block;
    return e.proposal_id;
  } else {
    let o = el.outline;
    return o.proposal_id;
  }
}

/**
 * Set the `proposal_id` of the `ProposalElement`.
 *
 * ```gleam
 * fn proposal_id(el: ProposalElement) {
 *   case element {
 *     proposal_element.Block(block) ->
 *       proposal_element.Block(block.Block(..block, proposal_id:))
 *     proposal_element.Question(question) ->
 *       proposal_element.Question(question.Question(..question, proposal_id:))
 *     proposal_element.Table(table) ->
 *       proposal_element.Table(table.Table(..table, proposal_id:))
 *   }
 * }
 * ```
 */
export function set_proposal_id(el, proposal_id) {
  if (el instanceof Question) {
    let e = el.question;
    return new Question(
      new $question.Question(
        e.id,
        proposal_id,
        e.owner,
        e.content,
        e.answer,
        e.validated,
        e.metadata,
        e.ai_processing,
        e.assign_processing,
        e.qa_order,
        e.doc_id_order,
        e.parent_id,
        e.created_at,
        e.updated_at,
      ),
    );
  } else if (el instanceof Table) {
    let e = el.table;
    return new Table(
      new $table.Table(
        e.id,
        proposal_id,
        e.element_type,
        e.owner,
        e.content,
        e.doc_id_order,
        e.metadata,
        e.qa_order,
        e.ai_processing,
        e.updated_at,
        e.created_at,
      ),
    );
  } else if (el instanceof Block) {
    let e = el.block;
    return new Block(
      new $block.Block(
        e.element_type,
        e.id,
        e.owner,
        e.content,
        e.doc_id_order,
        e.metadata,
        proposal_id,
        e.qa_order,
        e.ai_processing,
        e.updated_at,
        e.created_at,
      ),
    );
  } else {
    let o = el.outline;
    return new Outline(
      new $outline.Outline(
        o.id,
        o.owner,
        o.content,
        o.doc_id_order,
        proposal_id,
        o.qa_order,
        o.ai_processing,
        o.metadata,
        o.parent_id,
        o.updated_at,
        o.created_at,
      ),
    );
  }
}

/**
 * Access the `owner` of the `ProposalElement`.
 *
 * ```gleam
 * fn proposal_id(el: ProposalElement) {
 *   case element {
 *     proposal_element.Block(element) -> block.owner
 *     proposal_element.Question(question) -> question.owner
 *     proposal_element.Table(table) -> table.owner
 *   }
 * }
 * ```
 */
export function owner(el) {
  if (el instanceof Question) {
    let q = el.question;
    return q.owner;
  } else if (el instanceof Table) {
    let e = el.table;
    return e.owner;
  } else if (el instanceof Block) {
    let e = el.block;
    return e.owner;
  } else {
    let o = el.outline;
    return o.owner;
  }
}

/**
 * Access the `doc_id_order` of the `ProposalElement`.
 *
 * ```gleam
 * fn proposal_id(el: ProposalElement) {
 *   case element {
 *     proposal_element.Block(element) -> block.doc_id_order
 *     proposal_element.Question(question) -> question.doc_id_order
 *     proposal_element.Table(table) -> table.doc_id_order
 *   }
 * }
 * ```
 */
export function doc_id_order(el) {
  if (el instanceof Question) {
    let q = el.question;
    return q.doc_id_order;
  } else if (el instanceof Table) {
    let e = el.table;
    return e.doc_id_order;
  } else if (el instanceof Block) {
    let e = el.block;
    return e.doc_id_order;
  } else {
    let o = el.outline;
    return o.doc_id_order;
  }
}

/**
 * Access the `qa_order` of the `ProposalElement`.
 *
 * ```gleam
 * fn proposal_id(el: ProposalElement) {
 *   case element {
 *     proposal_element.Block(element) -> block.qa_order
 *     proposal_element.Question(question) -> question.qa_order
 *     proposal_element.Table(table) -> table.qa_order
 *   }
 * }
 * ```
 */
export function qa_order(el) {
  if (el instanceof Question) {
    let q = el.question;
    return q.qa_order;
  } else if (el instanceof Table) {
    let e = el.table;
    return e.qa_order;
  } else if (el instanceof Block) {
    let e = el.block;
    return e.qa_order;
  } else {
    let o = el.outline;
    return o.qa_order;
  }
}

/**
 * Access the `ai_processing` of the `ProposalElement`.
 *
 * ```gleam
 * fn proposal_id(el: ProposalElement) {
 *   case element {
 *     proposal_element.Block(element) -> block.ai_processing
 *     proposal_element.Question(question) -> question.ai_processing
 *     proposal_element.Table(table) -> table.ai_processing
 *   }
 * }
 * ```
 */
export function ai_processing(el) {
  if (el instanceof Question) {
    let q = el.question;
    return q.ai_processing;
  } else if (el instanceof Table) {
    let e = el.table;
    return e.ai_processing;
  } else if (el instanceof Block) {
    let e = el.block;
    return e.ai_processing;
  } else {
    let o = el.outline;
    return o.ai_processing;
  }
}

export function set_ai_processing(el, ai_processing) {
  if (el instanceof Question) {
    let e = el.question;
    return new Question(
      new $question.Question(
        e.id,
        e.proposal_id,
        e.owner,
        e.content,
        e.answer,
        e.validated,
        e.metadata,
        ai_processing,
        e.assign_processing,
        e.qa_order,
        e.doc_id_order,
        e.parent_id,
        e.created_at,
        e.updated_at,
      ),
    );
  } else if (el instanceof Table) {
    let e = el.table;
    return new Table(
      new $table.Table(
        e.id,
        e.proposal_id,
        e.element_type,
        e.owner,
        e.content,
        e.doc_id_order,
        e.metadata,
        e.qa_order,
        ai_processing,
        e.updated_at,
        e.created_at,
      ),
    );
  } else if (el instanceof Block) {
    let e = el.block;
    return new Block(
      new $block.Block(
        e.element_type,
        e.id,
        e.owner,
        e.content,
        e.doc_id_order,
        e.metadata,
        e.proposal_id,
        e.qa_order,
        ai_processing,
        e.updated_at,
        e.created_at,
      ),
    );
  } else {
    let o = el.outline;
    return new Outline(
      new $outline.Outline(
        o.id,
        o.owner,
        o.content,
        o.doc_id_order,
        o.proposal_id,
        o.qa_order,
        ai_processing,
        o.metadata,
        o.parent_id,
        o.updated_at,
        o.created_at,
      ),
    );
  }
}

export function set_doc_id_order(el, doc_id_order) {
  if (el instanceof Question) {
    let e = el.question;
    return new Question(
      new $question.Question(
        e.id,
        e.proposal_id,
        e.owner,
        e.content,
        e.answer,
        e.validated,
        e.metadata,
        e.ai_processing,
        e.assign_processing,
        e.qa_order,
        doc_id_order,
        e.parent_id,
        e.created_at,
        e.updated_at,
      ),
    );
  } else if (el instanceof Table) {
    let e = el.table;
    return new Table(
      new $table.Table(
        e.id,
        e.proposal_id,
        e.element_type,
        e.owner,
        e.content,
        doc_id_order,
        e.metadata,
        e.qa_order,
        e.ai_processing,
        e.updated_at,
        e.created_at,
      ),
    );
  } else if (el instanceof Block) {
    let e = el.block;
    return new Block(
      new $block.Block(
        e.element_type,
        e.id,
        e.owner,
        e.content,
        doc_id_order,
        e.metadata,
        e.proposal_id,
        e.qa_order,
        e.ai_processing,
        e.updated_at,
        e.created_at,
      ),
    );
  } else {
    let o = el.outline;
    return new Outline(
      new $outline.Outline(
        o.id,
        o.owner,
        o.content,
        doc_id_order,
        o.proposal_id,
        o.qa_order,
        o.ai_processing,
        o.metadata,
        o.parent_id,
        o.updated_at,
        o.created_at,
      ),
    );
  }
}

/**
 * Access the `parent_id` of the `ProposalElement`.
 *
 * ```gleam
 * pub fn parent_id(el: ProposalElement) {
 *   case el {
 *     Question(question:) -> question.parent_id
 *     Block(_) -> None
 *     Table(_) -> None
 *   }
 * }
 * ```
 */
export function parent_id(el) {
  if (el instanceof Question) {
    let question$1 = el.question;
    return question$1.parent_id;
  } else if (el instanceof Table) {
    return new None();
  } else if (el instanceof Block) {
    return new None();
  } else {
    let o = el.outline;
    return o.metadata.block_parent_id;
  }
}

/**
 * Access the `paragraph_id` of the `ProposalElement`.
 *
 * ```gleam
 * pub fn paragraph_id(el: ProposalElement) {
 *   case el {
 *     Table(..) -> None
 *     Outline(..) -> None
 *     Block(block:) -> block.metadata.paragraph_id
 *     Question(question:) -> {
 *       case question.metadata {
 *         question.PortalQuestion(..) -> None
 *         question.SheetQuestion(..) as m -> m.paragraph_id
 *       }
 *     }
 *   }
 * }
 * ```
 */
export function paragraph_id(el) {
  if (el instanceof Question) {
    let question$1 = el.question;
    let $ = question$1.metadata;
    if ($ instanceof $question.PortalQuestion) {
      return new None();
    } else {
      let m = $;
      return m.paragraph_id;
    }
  } else if (el instanceof Table) {
    return new None();
  } else if (el instanceof Block) {
    let block$1 = el.block;
    return block$1.metadata.paragraph_id;
  } else {
    return new None();
  }
}

function steerlab_outline(outline) {
  let order = $int.to_string(outline.doc_id_order);
  let index = $a.attribute("data-index", order);
  let id_ = $a.attribute("data-id", outline.id);
  let attrs = toList([index, id_]);
  let $ = outline.ai_processing;
  if ($) {
    let loading = $a.attribute("data-loading", "true");
    let _block;
    let _pipe = "<p></p>";
    let _pipe$1 = $a.inner_html(_pipe);
    _block = $a.dangerously_set_inner_html(_pipe$1);
    let children = _block;
    return $h.element(
      "steerlab-block",
      listPrepend(children, listPrepend(loading, attrs)),
      toList([]),
    );
  } else {
    let _block;
    let _pipe = outline.content;
    let _pipe$1 = $a.inner_html(_pipe);
    _block = $a.dangerously_set_inner_html(_pipe$1);
    let children = _block;
    return $h.element(
      "steerlab-block",
      listPrepend(children, attrs),
      toList([]),
    );
  }
}

function steerlab_answer(attrs, children) {
  let children$1 = $a.inner_html(children);
  let children$2 = $a.dangerously_set_inner_html(children$1);
  return $h.element(
    "steerlab-answer",
    listPrepend(children$2, attrs),
    toList([]),
  );
}

function steerlab_subject(attrs, children) {
  let children$1 = $a.inner_html(children);
  let children$2 = $a.dangerously_set_inner_html(children$1);
  let editable = $a.content_editable(false);
  return $h.element(
    "steerlab-subject",
    listPrepend(children$2, listPrepend(editable, attrs)),
    toList([]),
  );
}

function steerlab_question(attrs, children) {
  return $h.element("steerlab-question", attrs, children);
}

function map_attribute(value, data_key) {
  let _pipe = value;
  let _pipe$1 = $option.map(
    _pipe,
    (_capture) => { return $a.attribute(data_key, _capture); },
  );
  return $option.lazy_unwrap(_pipe$1, $a.none);
}

function is_block_editable(content) {
  let is_image = $string.contains(content, "steerlab-image");
  let is_block_processing = $string.contains(
    content,
    "steerlab-block-processing",
  );
  let is_editable = is_image || is_block_processing;
  return $bool.lazy_guard(
    !is_editable,
    $a.none,
    () => { return $a.attribute("editable", "false"); },
  );
}

function steerlab_block(attrs, children) {
  let editable = is_block_editable(children);
  let attrs$1 = listPrepend(editable, attrs);
  let children$1 = $a.inner_html(children);
  let children$2 = $a.dangerously_set_inner_html(children$1);
  return $h.element(
    "steerlab-block",
    listPrepend(children$2, attrs$1),
    toList([]),
  );
}

export function to_docs(el, owner) {
  let order = $int.to_string(doc_id_order(el));
  let index = $a.attribute("data-index", order);
  let id_ = $a.attribute("data-id", id(el));
  let kind = (k) => { return $a.attribute("data-kind", $kind.to_string(k)); };
  let _block;
  if (el instanceof Question) {
    let question$1 = el.question;
    let long = $question.get_textual_answer(question$1);
    let long$1 = $option.map(long, (a) => { return a.value; });
    let _block$1;
    if (long$1 instanceof Some) {
      let $ = long$1[0];
      if ($ === "") {
        _block$1 = "<p></p>";
      } else {
        let value = $;
        _block$1 = value;
      }
    } else {
      _block$1 = "<p></p>";
    }
    let answer = _block$1;
    let status = $a.attribute(
      "data-status",
      (() => {
        let $ = question$1.validated;
        if ($) {
          return "complete";
        } else {
          return "in-review";
        }
      })(),
    );
    let picture = $option.then$(owner, (u) => { return u.picture; });
    let initials = $option.map(owner, (u) => { return u.initials; });
    let picture$1 = map_attribute(picture, "data-picture");
    let initials$1 = map_attribute(initials, "data-initials");
    let _block$2;
    let _pipe = $question.score(question$1);
    let _pipe$1 = $option.map(
      _pipe,
      (_capture) => { return $float.multiply(_capture, 100.0); },
    );
    let _pipe$2 = $option.map(_pipe$1, $float.round);
    let _pipe$3 = $option.map(_pipe$2, $int.to_string);
    _block$2 = map_attribute(_pipe$3, "data-score");
    let score = _block$2;
    _block = steerlab_question(
      toList([index, id_, status, picture$1, initials$1, score]),
      toList([
        steerlab_subject(
          toList([id_, status, picture$1, initials$1]),
          question$1.content,
        ),
        steerlab_answer(toList([id_]), answer),
      ]),
    );
  } else if (el instanceof Table) {
    let e = el.table;
    _block = steerlab_block(
      toList([index, id_, kind(e.element_type)]),
      e.content,
    );
  } else if (el instanceof Block) {
    let e = el.block;
    _block = steerlab_block(
      toList([index, id_, kind(e.element_type)]),
      e.content,
    );
  } else {
    let o = el.outline;
    _block = steerlab_outline(o);
  }
  let _pipe = _block;
  return $dom.to_string(_pipe);
}

function gather_table_questions_answers(elements, table, default_language) {
  return $list.fold(
    elements,
    [$dict.new$(), $dict.new$()],
    (all, element) => {
      return $bool.guard(
        !isEqual(parent_id(element), new Some(id(table))),
        all,
        () => {
          let questions = all[0];
          let answers = all[1];
          if (element instanceof Question) {
            let question$1 = element.question;
            let _block;
            let $ = question$1.metadata;
            if ($ instanceof $question.PortalQuestion) {
              _block = questions;
            } else {
              let $1 = $.position;
              if ($1 instanceof Some) {
                let x = $1[0][0];
                let y = $1[0][1];
                _block = $dict.insert(questions, [x, y], question$1.content);
              } else {
                _block = questions;
              }
            }
            let questions$1 = _block;
            let answers$1 = $dict.fold(
              question$1.answer,
              answers,
              (answers, _, answer) => {
                let $1 = answer.position;
                if ($1 instanceof Some) {
                  let x = $1[0][0];
                  let y = $1[0][1];
                  let _pipe = $question.get_answer(
                    question$1,
                    answer.kind,
                    default_language,
                  );
                  let _pipe$1 = $option.unwrap(_pipe, "<p></p>");
                  return ((_capture) => {
                    return $dict.insert(answers, [x, y], _capture);
                  })(_pipe$1);
                } else {
                  return answers;
                }
              },
            );
            return [questions$1, answers$1];
          } else if (element instanceof Table) {
            return all;
          } else if (element instanceof Block) {
            return all;
          } else {
            return all;
          }
        },
      );
    },
  );
}

/**
 * Normalize a list of elements, removing subelements, injecting
 * questions/answers in table.
 */
export function normalize(elements, language) {
  return $list.filter_map(
    elements,
    (element) => {
      let _block;
      if (element instanceof Question) {
        let question$1 = element.question;
        if (!(question$1.parent_id instanceof None)) {
          _block = true;
        } else {
          _block = false;
        }
      } else {
        _block = false;
      }
      let is_subelement = _block;
      return $bool.guard(
        is_subelement,
        new Error(undefined),
        () => {
          if (element instanceof Question) {
            let question$1 = element.question;
            return new Ok(new Question(question$1));
          } else if (element instanceof Table) {
            let e = element.table;
            let $ = gather_table_questions_answers(elements, element, language);
            let questions = $[0];
            let answers = $[1];
            let _pipe = $table.inject_questions(e, questions, answers);
            let _pipe$1 = new Table(_pipe);
            return new Ok(_pipe$1);
          } else if (element instanceof Block) {
            let e = element.block;
            return new Ok(new Block(e));
          } else {
            let outline$1 = element.outline;
            return new Ok(new Outline(outline$1));
          }
        },
      );
    },
  );
}

function get_multi_choices(question) {
  let answers = $dict.to_list(question.answer);
  let _pipe = $list.find(
    answers,
    (a) => { return a[1].kind instanceof $question.MultipleChoice; },
  );
  let _pipe$1 = $result.lazy_or(
    _pipe,
    () => {
      return $list.find(
        answers,
        (a) => { return a[1].kind instanceof $question.YesNo; },
      );
    },
  );
  let _pipe$2 = $result.map(_pipe$1, (a) => { return a[1].value; });
  return $result.unwrap(_pipe$2, "");
}

function get_text(question) {
  let _pipe = $question.get_textual_answer(question);
  let _pipe$1 = $option.map(_pipe, (a) => { return a.value; });
  return $option.unwrap(_pipe$1, "");
}

function map_answer(question) {
  return (answer) => {
    if (answer instanceof $one_trust.ComposedAnswer) {
      let l = answer.sub_answers;
      return new $one_trust.ComposedAnswer(
        (() => {
          let _pipe = l;
          return $list.map(_pipe, map_answer(question));
        })(),
      );
    } else if (answer instanceof $one_trust.AnswerButton) {
      let bo = answer.button_options;
      return new $one_trust.AnswerButton(get_multi_choices(question), bo);
    } else if (answer instanceof $one_trust.AnswerRichText) {
      return new $one_trust.AnswerRichText(get_text(question));
    } else if (answer instanceof $one_trust.AnswerInputText) {
      return new $one_trust.AnswerInputText(get_text(question));
    } else if (answer instanceof $one_trust.AnswerMultiChoices) {
      let mc = answer.multi_choice_options;
      return new $one_trust.AnswerMultiChoices(
        toList([get_multi_choices(question)]),
        mc,
      );
    } else {
      return answer;
    }
  };
}

function insert_answer(question, one_trust_question) {
  let $ = question.metadata;
  if ($ instanceof $question.PortalQuestion) {
    let answer = map_answer(question)(one_trust_question.answer);
    return new Ok(
      new $one_trust.Question(
        one_trust_question.question_id,
        one_trust_question.question_text,
        one_trust_question.question_display_number,
        one_trust_question.answer_type,
        one_trust_question.section_id,
        one_trust_question.section_index,
        answer,
      ),
    );
  } else {
    return new Error("Wrong metadata type: SheetQuestion");
  }
}

export function question_to_one_trust(question) {
  let $ = question.metadata;
  if ($ instanceof $question.PortalQuestion) {
    let one_trust_question = $.question;
    return insert_answer(question, one_trust_question);
  } else {
    return new Error("Wrong metadata type: SheetQuestion");
  }
}

export function element_to_one_trust(element) {
  if (element instanceof Question) {
    let question$1 = element.question;
    return question_to_one_trust(question$1);
  } else if (element instanceof Table) {
    return new Error("Wrong element type: Table");
  } else if (element instanceof Block) {
    return new Error("Wrong element type: Block");
  } else {
    return new Error("Wrong element type: Block");
  }
}

export function updated_at(el) {
  if (el instanceof Question) {
    let q = el.question;
    return q.updated_at;
  } else if (el instanceof Table) {
    let e = el.table;
    return e.updated_at;
  } else if (el instanceof Block) {
    let e = el.block;
    return e.updated_at;
  } else {
    let o = el.outline;
    return o.updated_at;
  }
}

export function created_at(el) {
  if (el instanceof Question) {
    let q = el.question;
    return q.created_at;
  } else if (el instanceof Table) {
    let e = el.table;
    return e.created_at;
  } else if (el instanceof Block) {
    let e = el.block;
    return e.created_at;
  } else {
    let o = el.outline;
    return o.created_at;
  }
}

export function sort_by_doc_id(e1, e2) {
  let e1$1 = doc_id_order(e1);
  let e2$1 = doc_id_order(e2);
  return $int.compare(e1$1, e2$1);
}

export function to_docx(element) {
  if (element instanceof Question) {
    let question$1 = element.question;
    return $docx.from_question(question$1);
  } else if (element instanceof Table) {
    let table = element.table;
    return $docx.from_table(table);
  } else if (element instanceof Block) {
    let block$1 = element.block;
    return new Ok($docx.from_block(block$1));
  } else {
    let outline$1 = element.outline;
    return $docx.from_outline(outline$1);
  }
}

export function invalidate(element) {
  if (element instanceof Question) {
    let q = element.question;
    return new Question(
      new $question.Question(
        q.id,
        q.proposal_id,
        q.owner,
        q.content,
        q.answer,
        false,
        q.metadata,
        q.ai_processing,
        q.assign_processing,
        q.qa_order,
        q.doc_id_order,
        q.parent_id,
        q.created_at,
        q.updated_at,
      ),
    );
  } else if (element instanceof Table) {
    return element;
  } else if (element instanceof Block) {
    return element;
  } else {
    return element;
  }
}

export function validate(element) {
  if (element instanceof Question) {
    let q = element.question;
    return new Question(
      new $question.Question(
        q.id,
        q.proposal_id,
        q.owner,
        q.content,
        q.answer,
        true,
        q.metadata,
        q.ai_processing,
        q.assign_processing,
        q.qa_order,
        q.doc_id_order,
        q.parent_id,
        q.created_at,
        q.updated_at,
      ),
    );
  } else if (element instanceof Table) {
    return element;
  } else if (element instanceof Block) {
    return element;
  } else {
    return element;
  }
}
